/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Insert_Event_BelowInputs */

const en_shortcut_keys_name_insert_event_below = /** @type {(inputs: Shortcut_Keys_Name_Insert_Event_BelowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insert Event (Below)`)
};

const fr_shortcut_keys_name_insert_event_below = /** @type {(inputs: Shortcut_Keys_Name_Insert_Event_BelowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserer un evenement (en dessous)`)
};

const de_shortcut_keys_name_insert_event_below = /** @type {(inputs: Shortcut_Keys_Name_Insert_Event_BelowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignis einfügen (unten)`)
};

const it_shortcut_keys_name_insert_event_below = /** @type {(inputs: Shortcut_Keys_Name_Insert_Event_BelowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci evento (sotto)`)
};

const ru_shortcut_keys_name_insert_event_below = /** @type {(inputs: Shortcut_Keys_Name_Insert_Event_BelowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставить событие (ниже)`)
};

const es_shortcut_keys_name_insert_event_below = /** @type {(inputs: Shortcut_Keys_Name_Insert_Event_BelowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertar evento (abajo)`)
};

const zh_cn2_shortcut_keys_name_insert_event_below = /** @type {(inputs: Shortcut_Keys_Name_Insert_Event_BelowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`插入事件（如下）`)
};

const ja_shortcut_keys_name_insert_event_below = /** @type {(inputs: Shortcut_Keys_Name_Insert_Event_BelowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントを挿入（下）`)
};

const hi_shortcut_keys_name_insert_event_below = /** @type {(inputs: Shortcut_Keys_Name_Insert_Event_BelowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट डालें (नीचे)`)
};

const pt_pt2_shortcut_keys_name_insert_event_below = /** @type {(inputs: Shortcut_Keys_Name_Insert_Event_BelowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserir evento (abaixo)`)
};

/**
* | output |
* | --- |
* | "Insert Event (Below)" |
*
* @param {Shortcut_Keys_Name_Insert_Event_BelowInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_insert_event_below = /** @type {((inputs?: Shortcut_Keys_Name_Insert_Event_BelowInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Insert_Event_BelowInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_insert_event_below(inputs)
	if (locale === "de") return de_shortcut_keys_name_insert_event_below(inputs)
	if (locale === "it") return it_shortcut_keys_name_insert_event_below(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_insert_event_below(inputs)
	if (locale === "es") return es_shortcut_keys_name_insert_event_below(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_insert_event_below(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_insert_event_below(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_insert_event_below(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_insert_event_below(inputs)
	return en_shortcut_keys_name_insert_event_below(inputs)
});